// src/lib/hooks/useNotificationsUpdater.js
import { useDispatch } from "react-redux";
import { getNotificationsUnread } from "../apiCalls";
import { notificationsActions } from "../stores/notifications";

export function useNotificationsUpdater() {

  const dispatch = useDispatch();

  async function update() {
    const notification = await getNotificationsUnread(1);
    console.log(notification.data.data)
    dispatch(notificationsActions.addItemToList(notification.data.data));
  };

  return { update };
}